import { INIT_REDUCER } from './SharedActions';

/**
 * Společný store pro různá data, např. pro globální čísleníky pro fieldy atp. Převážně využíván např. fieldy z shared (jako StatField atp.).
 */
const initialState = {
    stores: {},   // mapa název reduceru na jeho store
    reducer: shared,
};

export default function shared(state = initialState, action: {type?: string, area: string, store?: any} = {area: ''}) {
    switch (action.type) {
        case INIT_REDUCER: {
            const area = action.area;
            return {
                ...state,
                stores: {
                    ...state.stores,
                    [area]: action.store,
                },
            };
        }
        default:
            if (action.area) {
                const store = state.stores[action.area];
                if (store) {
                    const newStore = store.reducer(store, action);
                    return {
                        ...state,
                        stores: {
                            ...state.stores,
                            [action.area]: newStore,
                        },
                    };
                } else {
                    return state;
                }
            } else {
                return state;
            }
    }
}
